module.exports = __webpack_public_path__ + "static/media/brand-story-img1.5583766c.png";